import { ProxyMap } from '@tencent/workbench-core';

class PostConstructorRegistryMap extends ProxyMap {
    setCallback(token, callback) {
        if (!this.get(token)) {
            this.set(token, []);
        }
        const callbacks = this.get(token);
        callbacks === null || callbacks === void 0 ? void 0 : callbacks.push(callback);
    }
}
/**
 * postContructor注册中心
 *
 * @internal
 */
const PostConstructorRegistry = new PostConstructorRegistryMap();

export { PostConstructorRegistry };
//# sourceMappingURL=post-constructor.js.map
